import React from "react";
import { cn } from "@/lib/utils";
import { isFilled, LinkField } from "@prismicio/client";
import AppLink from "@/components/atoms/Links/AppLink";

type OptInProps = {
  label: string;
  onCheckedChange?: (checked: boolean) => void;
  checked?: boolean;
  id?: string;
  className?: string;
  disabled?: boolean;
  link?: LinkField;
  linkText?: string;
};

const OptIn = ({ id, label, checked, onCheckedChange, className, disabled, link, linkText }: OptInProps) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (onCheckedChange) {
      onCheckedChange(e.target.checked);
    }
  };

  return (
    <label
      htmlFor={id || "terms"}
      className={cn("text-dark-primary flex cursor-pointer items-center gap-2 text-sm", className)}
    >
      <input
        type="checkbox"
        id={id || "terms"}
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        className={cn(
          "border-primary-light mt-1 size-4 shrink-0 rounded-full border-[0.5px]",
          "accent-blue-brand",
          "focus:ring-blue-brand/50 focus:ring-4 focus:outline-none",
          "disabled:cursor-not-allowed disabled:opacity-70"
        )}
        aria-label={label}
      />
      <p className="mt-0.5">{label}</p>
      {isFilled.link(link) && (
        <AppLink
          className="text-pink-primary font-medium underline underline-offset-2 transition-all duration-200 ease-in-out hover:scale-[102%]"
          field={link}
        >
          {link.text ? link.text : linkText}
        </AppLink>
      )}
    </label>
  );
};

export default OptIn;
